import { makeStyles, createStyles } from '@material-ui/core'

export const useMenuServiceStyles = makeStyles((theme) =>
  createStyles({
    usermenu: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 4,
      [theme.breakpoints.up('lg')]: {
        gap: 50
      },
      [theme.breakpoints.down('md')]: {
        marginLeft: 'auto'
      }
    },

    dropdown: {
      position: 'relative'
    },

    headerLink: {
      textTransform: 'none',
      fontFamily: 'Montserrat',
      fontSize: 17,
      fontWeight: 500
    },

    opened: {
      color: 'red'
    },

    dropdownItems: {
      position: 'absolute',
      top: 35,
      left: 0,
      padding: '5px 14px',
      background: '#FFFFFF',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
      borderRadius: 6
    },

    dropdownItem: {
      padding: '10px',
      cursor: 'pointer',
      minWidth: 210,
      borderBottom: '1px solid rgba(0, 0, 0, 0.1)'
    },

    dropdownLink: {
      textDecoration: 'none',
      color: '#000'
    },

    lastItem: {
      borderBottom: 'none'
    },

    headerRight: {
      display: 'flex',
      alignItems: 'center',
      gap: 15,
      cursor: 'pointer'
    },

    alarmIcon: {
      fontSize: 22
    },

    mobileMenu: {
      position: 'absolute',
      top: 64,
      left: 0,
      width: '100%',
      background: '#fff',
      padding: '20px 18px 30px 18px',
      boxShadow: '0px 5px 8px -3px rgba(34, 60, 80, 0.2) inset'
    },

    mobileMenuButton: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      textTransform: 'none',
      padding: '10px 4px',
      fontWeight: 500,
      fontFamily: 'Montserrat, serif',
      fontSize: 18
    },

    subMobileMenu: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: 5
    },

    mobileMenuSubButton: {
      fontSize: 12,
      textTransform: 'none',
      fontWeight: 500,
      maxWidth: 165,
      fontFamily: 'Montserrat',
      textDecoration: 'none',
      marginLeft: 6,
      padding: '3px 9px 6px 0',
      color: '#000',
      borderBottom: '1px solid rgba(0, 0, 0, 0.1);',
      '&:last-child': {
        borderBottom: 'none'
      }
    },

    tabletMenuBtn: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 12
    },

    tabletMenuItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    },

    tabletMenuSubItem: {
      display: 'flex',
      flexDirection: 'column',
      padding: '5px 20px',
      color: '#000',
      textDecoration: 'none',
      cursor: 'pointer'
    }
  })
)
